import React from "react"
import { InputFieldInterface } from "../../const"

const InputField = ({ field, label, state, dispatch, readOnly = false, type = "text", defaultValue = "" }: InputFieldInterface) => {
    const captureInput = (e: React.FocusEvent<HTMLInputElement> | React.KeyboardEvent<HTMLInputElement>) => {
        const input = (e.target as HTMLInputElement).value
        const validation = state[field].validationFn(input)
        if (input && !validation) dispatch({ type: "set-value", payload: [field, input] })
        else dispatch({ type: "set-error", payload: [field, validation] })
    }

    return (
        <fieldset className={`input-field ${state[field]["err"] ? "invalid" : ""}`}>
            <label htmlFor={field}>
                {label} {state[field]["required"] ? "*" : ""}
            </label>
            <input
                onKeyDown={e  => {
                    if (e.key === "Enter") captureInput(e)
                }}
                id={field}
                data-testid={field}
                defaultValue={defaultValue}
                type={type}
                readOnly={readOnly}
                onBlur={captureInput}
            />
            <div className="field-error">{state[field]["err"]}</div>
        </fieldset>
    )
}

export default InputField